import { v4 as uuidv4 } from 'uuid';
import { isoCurrency } from "./utils";
export class Checkout {
    constructor(identifier, api) {
        this.stepsCount = 0;
        this.last_step = 0;
        this.lastEvent = null;
        this.identifier = identifier;
        this.unique = null;
        this.validatorAPI = api;
    }
    static getOrCreateCheckout(identifier, api) {
        if (!Checkout.internalInstance) {
            console.debug('creating checkout instance');
            Checkout.internalInstance = new Checkout(identifier, api);
            Checkout.internalInstance.loadFromStorage();
            return Checkout.internalInstance;
        }
        console.debug('getting new checkout instance');
        Checkout.internalInstance.loadFromStorage();
        return Checkout.internalInstance;
    }
    addPurchase(order_code) {
        console.log('addPurchase');
        var num_items = 0;
        var currency = isoCurrency(window.Clkec.cart.currency);
        try {
            if (window.fbq) {
                // Purchase content_ids, content_name, content_type, contents, currency, num_items, value
                num_items = 0;
                console.log(window.Clkec.cart.get_products());
                var contents = window.Clkec.cart.get_products().map((item) => {
                    num_items += item.quantity;
                    let totalDiscount = (item.discounts || []).reduce((sum, d) => { var _a; return sum + ((_a = d.total_discount) !== null && _a !== void 0 ? _a : 0); }, 0);
                    return {
                        'product_id': item.code,
                        'quantity': item.quantity,
                        'title': item.name,
                        'item_price': item.price + totalDiscount,
                    };
                });
                var content_type = 'product';
                if (contents.length > 1) {
                    content_type += '_group';
                }
                var purchaseData = {
                    "order_id": order_code,
                    "content_ids": contents.map((item) => { return item['product_id']; }),
                    "contents": contents,
                    "content_type": content_type,
                    "num_items": num_items,
                    "value": window.Clkec.cart.total,
                    "currency": currency
                };
                const eventId = "purchase_" + order_code;
                window.fbq("track", "Purchase", purchaseData, { eventID: eventId });
                console.log('CLKEC_EVENTS_EVENT', `window.fbq("track", "Purchase", ${JSON.stringify(purchaseData)}, { eventID: ${eventId} });`);
            }
        }
        catch (e) {
            console.error(e);
        }
        try {
            if (window.gtag) {
                num_items = 0;
                var total_taxes = 0;
                if (window.Clkec.cart.taxes) {
                    var total_taxes_values = Object.values(window.Clkec.cart.taxes).map(function (x) {
                        return x.total;
                    });
                    total_taxes = total_taxes_values.reduce((acc, cv) => acc + cv);
                }
                var items = window.Clkec.cart.get_products().map((item) => {
                    num_items += item.quantity;
                    return {
                        item_id: item.id,
                        item_name: item.name,
                        // discount: 2.22, esta item.discounts que es un []
                        // affiliation: 'Google Store',
                        item_brand: item.brand.name,
                        // item_category: 'pants',
                        // item_variant: 'black',
                        price: item.price,
                        currency: currency,
                        quantity: item.quantity
                    };
                });
                var gaPurchaseData = {
                    currency: currency,
                    transaction_id: order_code,
                    items: items,
                    // shipping: 0,
                    value: window.Clkec.cart.total,
                    tax: total_taxes
                };
                window.gtag('event', 'purchase', gaPurchaseData);
                console.log('CLKEC_EVENTS_EVENT', `window.gtag('event', 'purchase', ${JSON.stringify(gaPurchaseData)});`);
            }
        }
        catch (e) {
            console.error(e);
        }
        document.dispatchEvent(new CustomEvent('ClkecPurchase', {
            'detail': {
                'order_code': order_code,
                'checkout': this,
            }
        }));
    }
    changePaymentInfo(data) {
        var num_items = 0;
        var currency = isoCurrency(window.Clkec.cart.currency);
        try {
            if (window.fbq) {
                // AddPaymentInfo content_category, content_ids, contents, currency, value
                var contents = (window.Clkec.cart.get_products() || []).map((item) => {
                    num_items += item.quantity;
                    return {
                        'id': item.id || item.code,
                        'product_id': item.code || item.id,
                        'quantity': item.quantity,
                        'item_price': item.price
                    };
                });
                var paymentData = {
                    content_ids: contents.map((item) => item.product_id || item.id),
                    contents: contents,
                    num_items: num_items,
                    currency: currency,
                    value: window.Clkec.cart.total
                };
                window.fbq("track", "AddPaymentInfo", paymentData);
                console.log('CLKEC_EVENTS_EVENT', `window.fbq("track", "AddPaymentInfo", ${JSON.stringify(paymentData)});`);
            }
        }
        catch (e) {
            console.error(e);
        }
        try {
            if (window.gtag) {
                num_items = 0;
                var items = window.Clkec.cart.get_products().map((item) => {
                    num_items += item.quantity;
                    return {
                        item_id: item.id,
                        item_name: item.name,
                        // discount: 2.22, esta item.discounts que es un []
                        // affiliation: 'Google Store',
                        item_brand: item.brand.name,
                        // item_category: 'pants',
                        // item_variant: 'black',
                        price: item.price,
                        currency: currency,
                        quantity: item.quantity
                    };
                });
                window.gtag('event', 'add_shipping_info', {
                    currency: currency,
                    shipping_tier: data,
                    items: items,
                    value: window.Clkec.cart.total
                });
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    changeShipingInfo(data) {
    }
    startCheckout(cart, formSelector, finish_order) {
        this.cart = cart;
        if (!cart.is_valid()) {
            window.location.href = '/cart/';
            return;
        }
        console.debug('startCheckout', this.cart);
        this.formSelector = formSelector;
        let form = document.querySelector(this.formSelector);
        if (!this.uniqueInput) {
            this.uniqueInput = document.createElement('input');
            this.uniqueInput.type = 'hidden';
            this.uniqueInput.name = 'unique';
            if (this.unique) {
                this.uniqueInput.value = this.unique;
            }
            form.appendChild(this.uniqueInput);
        }
        this.data = Object({});
        this.loadFromStorage();
        console.debug('startCheckout', this.data);
        let stepTab = null;
        Object.keys(this.data).forEach(step => {
            if (step == 'extras') {
                return;
            }
            let step_data = this.data[step];
            if (step == '0') {
                console.debug('startCheckout', step, step_data);
                if (window.Clkec.user && window.Clkec.user.data) {
                    Object.keys(window.Clkec.user.data).forEach(ufield => {
                        if (step_data[`step-customer-${ufield}`] == undefined) {
                            this.data[step][`step-customer-${ufield}`] = window.Clkec.user.data[ufield] || '';
                        }
                        console.debug('startCheckout', 'user', ufield, window.Clkec.user.data[ufield], step_data[`step-customer-${ufield}`]);
                    });
                }
            }
            stepTab = document.querySelector(`.form-step-${step}`);
            if (step_data && stepTab) {
                Object.keys(step_data).forEach(field => {
                    if (!field) {
                        return;
                    }
                    let el = stepTab.querySelector(`[name=${field}]`);
                    console.debug('startCheckout', field, el);
                    if (el) {
                        if (el.type == 'radio' || el.type == 'checkbox') {
                            console.debug('startCheckout', field, el, el.type);
                            if (step_data[field] != null) {
                                let val;
                                if (el.type == 'radio') {
                                    val = stepTab.querySelector(`[name=${field}][value="${step_data[field]}"]`);
                                }
                                else {
                                    val = stepTab.querySelector(`[name=${field}]`);
                                }
                                if (val) {
                                    val.setAttribute('checked', 'checked');
                                    val.parentElement.classList.add('selected');
                                    val.dispatchEvent(new Event('change'));
                                }
                                else {
                                    console.log(`[name=${field}][value="${step_data[field]}"]`);
                                }
                            }
                            stepTab.querySelectorAll(`[name=${field}]`).forEach(input => {
                                console.debug('startCheckout', field, input, 'register change');
                                input.addEventListener("change", ievent => {
                                    this.saveSteps();
                                    this.lastEvent = ievent;
                                });
                            });
                        }
                        else {
                            let fname = field; //.replace('step-customer-', '')
                            fname = field;
                            let rname = fname.replace('step-customer-', '');
                            let value = step_data[rname] ? step_data[rname] : step_data[fname];
                            if (window.Clkec.user.data) {
                                let nvalue = value && value.length > 0 ? value : window.Clkec.user.data[rname];
                                if (nvalue) {
                                    value = nvalue;
                                }
                            }
                            if (!value) {
                                value = '';
                            }
                            el.value = value;
                            console.debug('startCheckout', fname, el, 'register change');
                            el.addEventListener("change", event => {
                                this.lastEvent = event;
                                this.saveSteps(false, true);
                            });
                        }
                    }
                });
            }
        });
        this.allSteps = document.querySelectorAll(`.form-step`);
        if (Object.keys(this.data).length <= 1) {
            this.allSteps.forEach(stepDiv => {
                stepDiv.querySelectorAll('input').forEach(el => {
                    console.debug('startCheckout', el.name, el, 'register change');
                    el.addEventListener("change", event => {
                        this.saveSteps();
                    });
                });
                stepDiv.querySelectorAll('textarea').forEach(el => {
                    console.debug('startCheckout', el.name, el, 'register change');
                    el.addEventListener("change", event => {
                        this.saveSteps();
                    });
                });
                stepDiv.querySelectorAll('select').forEach(el => {
                    console.debug('startCheckout', el.name, el, 'register change');
                    el.addEventListener("change", event => {
                        this.saveSteps();
                    });
                });
            });
        }
        this.saveSteps();
        this.verifyUnique();
        this.stepsCount = this.allSteps.length;
        if (finish_order) {
            const formData = new FormData(form);
            console.debug('finish_order', formData.entries());
            console.debug('finish_order', formData.values());
            form.submit();
        }
        document.dispatchEvent(new CustomEvent('CheckoutLoaded', {
            'detail': this
        }));
    }
    stringify() {
        return JSON.stringify({
            data: this.data,
            last_step: this.last_step,
        });
    }
    loadFromStorage() {
        let checkout = JSON.parse(localStorage.getItem(this.identifier));
        if (!checkout) {
            return this;
        }
        if (!checkout.last_step) {
            checkout.last_step = {};
        }
        if (!checkout.data) {
            checkout.data = {};
        }
        this.data = checkout.data;
        this.last_step = checkout.last_step;
        let extras = this.data['extras'];
        if (extras) {
            this.unique = extras['unique'];
            if (this.uniqueInput) {
                this.uniqueInput.value = this.unique;
            }
        }
        return this;
    }
    reset() {
        this.unique = null;
        if (this.uniqueInput) {
            this.uniqueInput.value = '';
        }
        localStorage.removeItem(this.identifier);
    }
    saveSteps(initial = false, force_save = false) {
        if (initial) {
            let checkout = JSON.parse(localStorage.getItem(this.identifier));
            if (checkout) {
                return;
            }
        }
        if (!this.cart) {
            return;
        }
        this.verifyUnique(force_save);
    }
    async verifyUnique(force_save = false) {
        if (this.lastEvent === window.event && !force_save) {
            return;
        }
        this.lastEvent = window.event;
        console.debug('======= verifyUnique =======');
        let extras = this.data['extras'];
        if (!extras) {
            extras = Object({});
        }
        this.data = this.getAllData();
        // if(!this.initial) {
        //   this.initial = true;
        //   this.unique = '30612e8d-eb8c-4583-b729-169ba21eb68a';
        // }
        if (!this.unique) {
            this.unique = uuidv4();
            window.event = new Event('change');
            if (this.uniqueInput) {
                this.uniqueInput.value = this.unique;
            }
        }
        extras['unique'] = this.unique;
        this.data['extras'] = extras;
        localStorage.setItem(this.identifier, this.stringify());
        this.saveDB();
        console.debug('checkout', 'saveSteps');
        let valid = await this.validatorAPI.verifyUnique(this.unique);
        if (valid) {
            return;
        }
        else {
            this.unique = null;
            this.verifyUnique(true);
        }
    }
    saveDB() {
        console.debug('checkout', 'saveDB');
        localStorage.setItem(this.identifier, this.stringify());
        document.dispatchEvent(new CustomEvent('CheckoutUpdated', {
            'detail': this.data
        }));
    }
    setExtra(key, extra) {
        console.log('setExtra');
        if (!this.data) {
            return;
        }
        if (Object.keys(this.data).indexOf('extras') < 0) {
            this.data['extras'] = Object({});
        }
        let extras = this.data['extras'];
        if (!extras) {
            extras = Object({});
        }
        extras[key] = extra;
        if (extra === null || extra === undefined) {
            delete extras[key];
        }
        this.data['extras'] = extras;
        this.saveSteps(false, true);
    }
    getExtra(key) {
        if (!this.data) {
            return {};
        }
        if (Object.keys(this.data).indexOf('extras') < 0) {
            this.data['extras'] = Object({});
        }
        return this.data['extras'][key];
    }
    getAllData() {
        console.log('checkout', 'getAllData');
        let all_content = Object({});
        document.querySelectorAll(`.form-step`).forEach(el => {
            let step_id = parseInt(el.id.split('-')[1]);
            all_content[step_id] = this.get_step_data(step_id);
        });
        return all_content;
    }
    get_step_data(step) {
        let stepdata = Object({});
        let stepDiv = document.querySelector(`.form-step-${step}`);
        if (!stepDiv) {
            return stepdata;
        }
        stepDiv.querySelectorAll('input[type="text"]').forEach((el) => {
            stepdata[el.name] = el.value;
        });
        stepDiv.querySelectorAll('input[type="email"]').forEach((el) => {
            stepdata[el.name] = el.value;
        });
        stepDiv.querySelectorAll('input[type="number"]').forEach((el) => {
            stepdata[el.name] = el.value;
        });
        let radioschecks = new Array();
        stepDiv.querySelectorAll('input[type=radio]').forEach((el) => {
            if (radioschecks.indexOf(el.name) >= 0) {
                return;
            }
            radioschecks.push(el.name);
        });
        stepDiv.querySelectorAll('input[type=checkbox]').forEach((el) => {
            if (radioschecks.indexOf(el.name) >= 0) {
                return;
            }
            radioschecks.push(el.name);
        });
        stepDiv.querySelectorAll('textarea').forEach((el) => {
            stepdata[el.name] = el.value;
        });
        radioschecks.forEach(field => {
            let el = stepDiv.querySelector(`[name=${field}]:checked`);
            if (el) {
                stepdata[field] = el.value;
            }
            else {
                stepdata[field] = null;
            }
        });
        stepDiv.querySelectorAll('select').forEach(el => {
            let value = el.options[el.selectedIndex];
            stepdata[el.name] = el.value;
        });
        console.log('checkout', 'step', stepdata);
        return stepdata;
    }
    /* SHIPPING */
    async apiShippingOptions() {
        return await this.validatorAPI.getShippingOptions();
    }
    async apiPaymentsOptions() {
        return await this.validatorAPI.getPaymentsOptions();
    }
    async listShippingOptions() {
        var options = await this.apiShippingOptions();
        var shipping_data = this.getExtra('shipping_data');
        if (shipping_data) {
            options.forEach(el => {
                el['selected'] = shipping_data['address'] == el.id;
            });
        }
        return options;
    }
    async listPaymentsOptions() {
        var options = await this.apiPaymentsOptions();
        var payments_data = this.getExtra('payments_data');
        if (payments_data) {
            options.forEach(el => {
                el['selected'] = payments_data['address'] == el.id;
            });
        }
        return options;
    }
}
